import avalaraImage from './avalaraCover.png'
import {
  Text,
  GreyGrey30,
  GreyGrey90,
  Image,
  ListItem,
  Primary13Regular,
  UnorderedList,
  Box,
  Flex
} from '@sequencehq/core-components'

export const AvalaraIntegrationDetail = () => {
  return (
    <Flex flexDirection="column" gap="20px">
      <Image
        src={avalaraImage}
        width="100%"
        aspectRatio={1288 / 512}
        borderRadius="8px"
        border={`1px solid ${GreyGrey30}`}
        draggable={false}
      />
      <Text {...Primary13Regular} color={GreyGrey90}>
        Integrate with Avalara to ensure your invoices are accurate and
        compliant with all state and local sales tax regulations. This connector
        requires an account with Avalara.
      </Text>
      <Box {...Primary13Regular} color={GreyGrey90} lineHeight="18px">
        <UnorderedList>
          <ListItem>
            <strong>Automated tax calculations:</strong> Calculate accurate
            sales tax for every invoice generated by Sequence
          </ListItem>
          <ListItem>
            <strong>Account for tax rate changes:</strong> Avalara automatically
            applies the latest tax rates and changes to your invoices
          </ListItem>
          <ListItem>
            <strong>Prevent tax errors:</strong> Avoid manual tax calculation
            errors and ensure compliance with local tax regulations
          </ListItem>
          <ListItem>
            <strong>Quick setup:</strong> Get your license key and integrate
            with Avalara in minutes
          </ListItem>
        </UnorderedList>
      </Box>
    </Flex>
  )
}
